//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import { createSlice } from '@reduxjs/toolkit';

import { CustomActionPythonState } from './types';

export const initialState: CustomActionPythonState = {
  customActionPythonWizardVisible: false,
  customActionPythonSharing: {
    visible: false,
  },
};

const customActionPythonSlice = createSlice({
  name: 'customActionPython',
  initialState,
  reducers: {
    showCustomActionPythonWizard: (state, action) => {
      state.customActionPythonWizardVisible = action.payload.visible;
    },
    showCustomActionPythonShare: (state, action) => {
      state.customActionPythonSharing = {
        visible: action.payload.visible,
        customActionPythonId: action.payload.customActionPythonId,
      };
    },
  },
});

export const {
  reducer,
  actions: { showCustomActionPythonWizard, showCustomActionPythonShare },
} = customActionPythonSlice;
